import { StyledSpinner, StyledWaitBox } from '../styled-components'

interface WaitBoxProps {
  text: string
}

const WaitBox = ({ text }: WaitBoxProps) => (
  <StyledWaitBox role='status'>
    <StyledSpinner aria-hidden='true' />
    <span>{text}</span>
  </StyledWaitBox>
)

export default WaitBox
